<template>
  <div class="flashHelp flexcenter">
    <transition>
      <div class="help flexcenter">
        <dl>
          <dd>
            <p v-if="platform.name == 'IE'">音声機能を有効にするには[Shockwave Flash Object]を有効にする必要があります。</p>
            <p v-if="platform.name == 'Safari'">音声機能を有効にするには[Adobe Flash Player]プラグインを有効にする必要があります。</p>
            <p>以下の手順に従って、設定します。</p>
            <p><a class="help-anchor" href="http://www.sourcenext.com/support/qa/?faq=RS-08935" target="_blank">http://www.sourcenext.com/support/qa/?faq=RS-08935</a></p>
            <p><a class="help-anchor" href="http://www.sourcenext.com/support/qa/?faq=RS-08885" target="_blank">http://www.sourcenext.com/support/qa/?faq=RS-08885</a></p>
          </dd>
        </dl>
        <button class="return" type="button" @click="$emit('close')"><span class="close_text">閉じる</span></button>
      </div>
    </transition>
  </div>
</template>

<script>
var platform = require("platform");

export default {
  name: "flashHelp",
  computed: {
    platform: () => platform
  },
  mounted: function() {
    this.setBodyStylePosition(true);
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false);
  }
};
</script>

<style lang="scss">
@import "src/assets/style/modal";
</style>



// WEBPACK FOOTER //
// FlashHelp.vue?24452a7c